// --------------------------------------------------------------
// Created On: 2024-08-06
// Author: Dimitra Weinstein
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./AttributeInformationRow.module.scss";

// Table row containing attribute information.
export default function AttributeInformationRow(props: Props): Component {
  return (
    <tr data-test="attribute-info-row" className={styles.body}>
      <td>{props.name}</td>
      <td>{props.description}</td>
    </tr>
  );
}

interface Props {
  name: string;
  description: string;
}
